var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRuler = function SvgRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m23.925 17.984-1.969-1.97-2.622 2.619a.509.509 0 1 1-.72-.72l2.621-2.622-1.977-1.978-1.264 1.263a.51.51 0 0 1-.72-.72l1.264-1.263-1.967-1.964-2.618 2.624a.51.51 0 0 1-.83-.555.5.5 0 0 1 .11-.165l2.622-2.623-1.976-1.974-1.265 1.265a.509.509 0 1 1-.72-.72l1.27-1.259-1.978-1.979-2.623 2.623a.51.51 0 0 1-.72-.72l2.63-2.616-1.98-1.975-1.259 1.262a.509.509 0 1 1-.72-.72L7.78 1.835 6.017.075a.25.25 0 0 0-.36 0L.074 5.66a.25.25 0 0 0 0 .36l17.909 17.905a.25.25 0 0 0 .36 0l5.584-5.584a.25.25 0 0 0 0-.36z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgRuler as ReactComponent };
export default "/_next/static/images/ruler.svg";